export default __webpack_public_path__ + "static/media/inicio-inact.e045e42a.svg";